<template>
    <div
        class="flex flex-col flex-shrink-0 items-center justify-center w-28 h-28 xs:basis-full"
        :class="[
            CONFIG_OPTIONS.global.roundedCorners ? 'rounded-xl' : '',
            CONFIG_OPTIONS.eventTeaser.bgColor,
            CONFIG_OPTIONS.eventTeaser.textColor,
        ]"
    >
        <div class="text-regular-400">{{ getDate().weekday }}</div>
        <div class="text-f4">{{ getDate().day }}</div>
        <div class="text-regular-400">
            {{ getDate().month }} {{ getDate().year }}
        </div>
    </div>
</template>

<script setup lang="ts">
import { CONFIG_OPTIONS } from "@src/globals";
import { getLocaleFromUrl } from "@src/i18n/utils";

const props = defineProps<{
    dateString: string;
}>();

const locale = getLocaleFromUrl(new URL(window.location.href));

const getDate = () => getDateObject(props.dateString);

/** @param _dateString ISO-8601 */
function getDateObject(_dateString: string): {
    weekday: string;
    day: string;
    month: string;
    year: string;
} {
    const date = new Date(_dateString);

    const weekday = date.toLocaleDateString(locale, {
        weekday: "short",
    });

    const day = date.toLocaleDateString(locale, {
        day: "2-digit",
    });

    const month = date.toLocaleDateString(locale, {
        month: "short",
    });

    const year = date.toLocaleDateString(locale, {
        year: "numeric",
    });

    return {
        weekday,
        day,
        month,
        year,
    };
}
</script>
